var map = {
	"./": "7423",
	"./createNewService": "972b",
	"./createNewService.js": "972b",
	"./createSLA": "6ee1",
	"./createSLA.js": "6ee1",
	"./deleteService": "a367",
	"./deleteService.js": "a367",
	"./getListOfServices": "9f2f",
	"./getListOfServices.js": "9f2f",
	"./getPartnerServices": "8d07",
	"./getPartnerServices.js": "8d07",
	"./getSLAContent": "b30b",
	"./getSLAContent.js": "b30b",
	"./getSLAList": "2789",
	"./getSLAList.js": "2789",
	"./getServiceDetails": "7447",
	"./getServiceDetails.js": "7447",
	"./getServiceFilters": "d1ef",
	"./getServiceFilters.js": "d1ef",
	"./getServiceIdByServiceName": "27a5",
	"./getServiceIdByServiceName.js": "27a5",
	"./getServiceList": "f7bd",
	"./getServiceList.js": "f7bd",
	"./getServiceListForTable": "5ed7",
	"./getServiceListForTable.js": "5ed7",
	"./getShortListOfServices": "c454",
	"./getShortListOfServices.js": "c454",
	"./index": "7423",
	"./index.js": "7423",
	"./patchServiceDetails": "56f2",
	"./patchServiceDetails.js": "56f2",
	"./patchServicesGroup": "d71e",
	"./patchServicesGroup.js": "d71e",
	"./refreshServices": "7622",
	"./refreshServices.js": "7622",
	"./removeSLA": "a801",
	"./removeSLA.js": "a801",
	"./searchServices": "65dc",
	"./searchServices.js": "65dc",
	"./searchServicesByNames": "b334",
	"./searchServicesByNames.js": "b334",
	"./updateSLA": "5795",
	"./updateSLA.js": "5795",
	"./updateServiceDetails": "d1c1",
	"./updateServiceDetails.js": "d1c1",
	"./uploadNewSLA": "f52a",
	"./uploadNewSLA.js": "f52a",
	"./uploadSLA": "5aff",
	"./uploadSLA.js": "5aff"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "bc4e";